import { render, staticRenderFns } from "./TabShortMenus.vue?vue&type=template&id=798a4958"
import script from "./TabShortMenus.vue?vue&type=script&lang=js"
export * from "./TabShortMenus.vue?vue&type=script&lang=js"
import style0 from "./TabShortMenus.vue?vue&type=style&index=0&id=798a4958&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('798a4958')) {
      api.createRecord('798a4958', component.options)
    } else {
      api.reload('798a4958', component.options)
    }
    module.hot.accept("./TabShortMenus.vue?vue&type=template&id=798a4958", function () {
      api.rerender('798a4958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Components/Header/TabShortMenus.vue"
export default component.exports